import { initialState } from "./";
import { setHeaderAuth } from "@/api";
import _unionWith from "lodash/unionWith";
import _merge from "lodash/merge";

export default {
  LOGIN(state, { token, customer }) {
    state.token = token;
    state.customer = customer;
    setHeaderAuth(token);
  },

  LOGOUT(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
    setHeaderAuth("");
  },

  STORE_CUSTOMER(state, customer) {
    state.customer = customer;
  },

  UPDATE_CUSTOMER(state, customer) {
    state.customer = _merge(state.customer, customer);
  },

  STORE_CARD(state, card) {
    state.customer.cards = state.customer.cards.push(card);
  },

  REMOVE_CARD(state, cardId) {
    state.customer.cards = state.customer.cards.filter((c) => c.id !== cardId);
  },

  STORE_FREQUENTS(state, frequents) {
    state.customer.frequents = frequents;
  },

  STORE_ORDER(state, order) {
    state.orders = _unionWith([order], state.orders, (a, b) => a.id === b.id);
  },

  STORE_ORDERS(state, orders) {
    state.orders = orders;
  },
  SET_ORDERS_FILTER(state, filter) {
    state.ordersFilter = filter;
  },
  UPDATE_ORDER(state, order) {
    const index = state.orders.findIndex((o) => o.id === order.id);
    state.orders.splice(index, 1, order);
  },

  STORE_NEW_ORDER(state, newOrder) {
    state.newOrder = newOrder;
  },
  STORE_LEGS(state, legs) {
    state.legs = legs;
  },
  SET_ZONES(state, zones) {
    state.zones = zones;
  },
  SET_ZONES_EXPRESS(state, zones) {
    state.zonesExpress = zones;
  },
  SET_ZONES_MERCADO_FLEX(state, zones) {
    state.zonesMercadoFlex = zones;
  },
  STORE_API_KEY(state, apiKey) {
    state.apiKey = apiKey;
  },
  STORE_TRACKING(state, tracking) {
    state.tracking = tracking;
  },
  STORE_EXAMPLE(state, example) {
    state.example = example;
  },
  STORE_ID_ORDER(state, idOrder) {
    state.id_order = idOrder;
  },
  STORE_NEW_EXPRESS(state, newExpress) {
    state.newExpress = newExpress;
  },
  STORE_NEW_MERCADO_FLEX(state, newMercadoFlex) {
    state.newMercadoFlex = newMercadoFlex;
  },
  STORE_REPORT_SERVICES(state, services) {
    state.reportServices = services;
  },
  STORE_REPORT_ORDERS(state, reportOrders) {
    state.reportOrders = reportOrders;
  },
  STORE_AVAILABLE_SERVICES(state, servicesObject) {
    state.servicesObject = servicesObject;
  },
  STORE_MERCADO_FLEX_INTEGRATION(state, mercadoFlexIntegration) {
    state.mercadoFlexIntegration = mercadoFlexIntegration;
  },
};
